import Can from "../../util/can";
import { Menu } from "antd";
import { PropTypes } from "prop-types";
import React from "react";
const MenuItemGroup = Menu.ItemGroup;

const PermissionGroupMenu = (props) => {
  const { resource, children } = props;

  return (
    <Can I="read" a={resource}>
      <MenuItemGroup {...props}>
        {children}
      </MenuItemGroup>
    </Can>
  );
};

PermissionGroupMenu.defaultProps = {
  resource: '',
};

PermissionGroupMenu.propTypes = {
  resource: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default PermissionGroupMenu;
